import {View} from "react-native";
import {FontAwesome5} from "@expo/vector-icons";
import {Layout, Text} from "@ui-kitten/components";
import { Bold } from "../../../shared/bold";
import * as React from "react";
import {Button} from "../../../shared/button";
import {TransparentBox} from "../../../ui/transparent-box";

export const FlexibilityExplain = (props) => {
    return <Layout level='2' style={{ backgroundColor: 'transparent', padding: 20 }}>
        <TransparentBox>
            <View style={{alignItems: "center"}}>
                <FontAwesome5 name="trash-restore" size={50} color='#a0c946'/>
            </View>

            <Text style={{
                fontSize: 25,
                lineHeight: 25,
                marginTop: 10,
                marginBottom: 20,
                textAlign: "center",
                color: "white"
            }}>Flexibility</Text>

            <View style={{ marginBottom: 20 }}>
                <Text style={{ color: 'white', lineHeight: 25 }}>
                    -  On demand <Text style={{color: '#a0c946', fontWeight: 'bold'}}>pick up request</Text>
                </Text>
                <Text style={{ color: 'white', lineHeight: 25 }}>
                    -  <Text style={{color: '#a0c946', fontWeight: 'bold'}}>Additional bin</Text> if required
                </Text>
            </View>

            <Button onPress={props.onSkip}>Continue</Button>
        </TransparentBox>
    </Layout>
}